import { TopThreatsController } from '../controller/TopThreatsController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class TopThreatsWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TopThreatsController,
    });
  }
}
